// CPC DEX — collapsible contract assets (moved from homepage)
import type { ClobMarketConfig } from '@cpc/tx';
import { ChevronDown12 } from '@mysten/icons';
import clsx from 'clsx';
import { useState } from 'react';

import { CpcAssetsList } from '~/components/cpc/CpcAssetsList';
import { getCpcAssetEntries } from '~/config/cpcAssets.config';
import { Card } from '~/ui/Card';

export function CpcTradeAssetsPanel({ market }: { market: ClobMarketConfig }) {
	const entries = getCpcAssetEntries(market);
	const [open, setOpen] = useState(false);
	const pair = `${market.baseSymbol ?? 'DGC'} / ${market.quoteSymbol ?? 'DATA'}`;

	if (entries.length === 0) return null;

	const summary = entries
		.map((e) => e.symbol ?? e.label)
		.slice(0, 4)
		.join(' · ');

	return (
		<Card bg="dark" spacing="sm" growOnHover={false}>
			<button
				type="button"
				className="flex w-full items-center justify-between gap-3 text-left"
				onClick={() => setOpen((v) => !v)}
				aria-expanded={open}
			>
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2">
						<span className="text-caption font-bold uppercase tracking-wider text-[#848E9C]">
							DEX 合约信息
						</span>
						<span className="rounded border border-white/10 bg-white/5 px-1.5 py-px text-[10px] font-semibold text-[#848E9C]">
							{pair}
						</span>
						<span className="rounded border border-white/10 bg-white/5 px-1.5 py-px text-[10px] font-semibold text-[#848E9C]">
							{entries.length}
						</span>
					</div>
					<p className="mt-1 truncate text-xs text-[#5E6673]" title={summary}>
						{summary}
					</p>
				</div>
				<span
					className={clsx(
						'flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-white/10 bg-white/5 text-[#848E9C] transition-transform',
						open && 'rotate-180 border-[#38BDF8]/30 text-[#38BDF8]',
					)}
				>
					<ChevronDown12 className="h-3.5 w-3.5" />
				</span>
			</button>

			{open ? (
				<div className="mt-3 border-t border-white/10 pt-3">
					<p className="mb-2 text-[11px] leading-relaxed text-[#848E9C]">
						本链 {pair} 与 CLOB 合约对象；RPC 校验后可跳转 Explorer 详情。
					</p>
					<CpcAssetsList variant="trade" entries={entries} />
				</div>
			) : null}
		</Card>
	);
}
